import { render, staticRenderFns } from "./PageEducatorInstitutionEvent.vue?vue&type=template&id=65e32279&scoped=true&"
import script from "./PageEducatorInstitutionEvent.vue?vue&type=script&lang=js&"
export * from "./PageEducatorInstitutionEvent.vue?vue&type=script&lang=js&"
import style0 from "./PageEducatorInstitutionEvent.vue?vue&type=style&index=0&id=65e32279&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e32279",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VContainer,VRow})
